import { useQuery } from "@tanstack/react-query";
import { getApiClient } from "../api-client";
import type {
  StaffRoomListItem,
  StaffRoomDetail,
  StaffRoomFilters,
} from "./types";

function buildListUrl(filters: StaffRoomFilters): string {
  const params = new URLSearchParams();
  if (filters.states.length > 0) {
    params.set("state", filters.states.join(","));
  }
  if (filters.search.trim().length > 0) {
    params.set("search", filters.search.trim());
  }
  if (filters.startsWithin7Days) {
    params.set("startsWithin", "7");
  }
  if (filters.lowMembers) {
    params.set("lowMembers", "true");
  }
  const qs = params.toString();
  return qs ? `/staff/plotlounge-rooms?${qs}` : "/staff/plotlounge-rooms";
}

export function usePlotloungeRoomsQuery(filters: StaffRoomFilters) {
  return useQuery<StaffRoomListItem[]>({
    queryKey: [
      "staff",
      "plotlounge-rooms",
      filters.states,
      filters.search.trim(),
      filters.startsWithin7Days,
      filters.lowMembers,
    ],
    queryFn: () =>
      getApiClient().get<StaffRoomListItem[]>(buildListUrl(filters)),
    staleTime: 30 * 1000,
  });
}

export function usePlotloungeRoomDetailQuery(id: string | undefined) {
  return useQuery<StaffRoomDetail>({
    queryKey: ["staff", "plotlounge-rooms", "detail", id],
    enabled: Boolean(id),
    queryFn: () =>
      getApiClient().get<StaffRoomDetail>(`/staff/plotlounge-rooms/${id}`),
    staleTime: 30 * 1000,
  });
}
